import React, {
  FC,
  ReactElement,
} from 'react';
import { useInView } from 'react-intersection-observer';
import GridRoot from '../GridRoot';
import {
  GridElementProps,
} from './types';

const GridElement: FC<GridElementProps> = (props: GridElementProps): ReactElement => {
  const {
    lazy = false,
    sizes,
    spacing = 0.5,
    children
  } = props;

  const { inView } = useInView({
    triggerOnce: true,
    rootMargin: '250px'
  });
  const shouldRender = !lazy || inView;

  const root = (
    <GridRoot
      elementSizes={sizes}
      spacing={spacing}
    >
      {shouldRender ? children : null}
    </GridRoot>
  );

  return root;
};

export default GridElement;
